<template>
  <div class="floor">
    <div class="floor__header">
      <slot name="title">
        <span class="floor-title">{{ title }}</span>
      </slot>
      <span class="floor-sub-title" :style="{ color: subTitleColor }">
        {{ subTitle }}
      </span>
      <span
        class="floor-show-more-text"
        v-if="showMore"
        @click="$emit('show-more')"
      >
        {{ showMoreText }}
      </span>
    </div>
    <div class="floor__content">
      <slot></slot>

      <van-empty
        v-if="showEmpty"
        :image="emptyImage"
        :description="emptyText"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Floor',
  props: {
    title: {
      type: String,
      require: false,
    },
    subTitle: {
      type: String,
      require: false,
    },
    subTitleColor: {
      type: String,
      require: false,
      default: '#595757',
    },
    showMore: {
      type: Boolean,
      require: false,
      default: true,
    },
    showMoreText: {
      type: String,
      require: false,
      default: '查看更多   >>',
    },
    showEmpty: {
      type: Boolean,
      require: false,
    },
    emptyImage: {
      type: String,
      require: false,
      default: require('@/assets/images/puhui/sy-w1.png'),
    },
    emptyText: {
      type: String,
      require: false,
      default: '暂无数据~',
    },
  },
};
</script>

<style lang="less" scoped>
@gray-color: #efefef;
@floor-margin-bottom: 6px;
@floor-background-color: #fff;

.floor {
  background-color: @floor-background-color;

  &:after {
    content: ' ';
    display: block;
    width: 100%;
    height: @floor-margin-bottom;
    background-color: @gray-color;
  }

  &__header {
    padding: 14px 0 0 20px;
    position: relative;
  }

  &-title {
    color: #000;
    font-size: 18px;
    font-weight: 600;
  }

  &-sub-title {
    margin-left: 6px;
    font-size: 15px;
  }

  &-show-more-text {
    position: absolute;
    right: 12px;
    bottom: 0;
    color: #595757;
    font-size: 14px;
  }

  &__content {
    padding: 10px 12px;
  }

  /deep/ .van-empty {
    &__image {
      width: 100px;
    }

    &__image,
    &__image img {
      height: auto;
      max-height: 100px;
    }

    &__description {
      font-size: 12px;
      margin-bottom: 0;
    }
  }
}
</style>
